import SafetyMeasureCategoryIcon from './SafetyMeasureCategoryIcon';

export default SafetyMeasureCategoryIcon;
